module.exports = __webpack_public_path__ + "static/media/banner-vivo-pay_new.395771ef.png";